import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOutboundsUngroupParams, TypePostOutboundsUngroupResponse } from '~/types/delivery-agency.types';

/**
 * [합포 단위 관리] 합포장 취소 API
 */
const fetchPostOutboundsUngroup = async (
  params: TypePostOutboundsUngroupParams
): Promise<TypePostOutboundsUngroupResponse['data']> => {
  const { data } = await axiosInstance.post<TypePostOutboundsUngroupResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.POST_OUTBOUNDS_UNGROUP,
    params
  );
  return data.data;
};

/**
 * [합포 단위 관리] 합포장 취소 Mutation Hook
 */
export const usePostOutboundsUngroupMutation = () => {
  return useMutation<
    TypePostOutboundsUngroupResponse['data'],
    TypeErrorResponseData['error'],
    TypePostOutboundsUngroupParams
  >({
    mutationFn: fetchPostOutboundsUngroup,
    meta: { silent: true },
  });
};
